import { apiClient } from "@/lib/api-client"

export interface CheckInUser {
  _id: string
  userId: {
    _id: string
    name: string
    surname: string
    email: string
    phone: string
    status: string
    gym: string[]
    userType: string
    expires: string
    dietPlans: any[]
    exercisePlans: any[]
    fcmTokens: any[]
    activePayment: string
    payments: string[]
    remainingEntries: number | null
    createdAt: string
    updatedAt: string
    __v: number
    pin: string
    systemId: string
  }
  gymId: string
  systemId: string
  checkIn: string
  checkOut: string | null
  createdAt: string
  updatedAt: string
  __v: number
}

export interface DashboardData {
  totalUsers: number
  totalUsersChange: number
  activeUsers: number
  activeUsersChange: number
  totalRevenue: number
  totalRevenueChange: number
  activeGyms: number
  recentUsers: {
    name: string
    email: string
    joinDate: string
  }[]
  recentPayments: {
    name: string
    method: string
    amount: number
  }[]
  hasActivePlans: boolean
  attandanceCount: CheckInUser[] // Fixed the typo to match the API response
}

export async function getDashboardData(gymId: string): Promise<DashboardData> {
  const response = await apiClient.get(`/users/dashboard/${gymId}`)
  return response.data
}

// Add the new check-in/out API function at the end of the file

export interface CheckInOutRecord {
  _id: string
  userId: {
    _id: string
    name: string
    surname: string
    email: string
    phone: string
    status: string
    gym: string[]
    userType: string
    expires: string
    dietPlans: any[]
    exercisePlans: any[]
    fcmTokens: any[]
    activePayment: string
    payments: string[]
    remainingEntries: number | null
    createdAt: string
    updatedAt: string
    __v: number
    pin: string
    systemId: string
  }
  gymId: {
    _id: string
    name: string
    address: string
    city: string
    country: string
    email: string
    phone: string
    facilities: string
    workingHours: string
    createdAt: string
    updatedAt: string
    __v: number
    systemId: string
  }
  systemId: string
  checkIn: string
  checkOut: string | null
  createdAt: string
  updatedAt: string
  __v: number
}

export async function getCheckInOutRecords(startDate: string, endDate: string, gymId?: string): Promise<CheckInOutRecord[]> {
  const url = gymId ? `/check-in-out/${startDate}/${endDate}?gymId=${gymId}` : `/check-in-out/${startDate}/${endDate}`
  const response = await apiClient.get(url)
  return response.data
}

export async function getUserCheckInOutRecords(userId: string, startDate: string, endDate: string): Promise<CheckInOutRecord[]> {
  const url = `/check-in-out/${startDate}/${endDate}?userId=${userId}`
  const response = await apiClient.get(url)
  return response.data
}
